import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import TextInput from '@xingternal/malt-text-input';
import {
  PrimaryButtonMedium as Button,
  TextButtonRegularMedium as TextButton,
} from '@xingternal/malt-button';

import PageviewTracker from '../../../Components/PageviewTracker/PageviewTracker';
import StretchButtonGroup from './../../../Components/StretchButtonGroup/StretchButtonGroup';
import Spacer from './../../../Components/Spacer/Spacer';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import messages from './messages';

const NewEmailStep = ({
  isSubmitting,
  handleChange,
  errors: { newEmailError },
  values: { newEmail },
}) => (
  <>
    <PageviewTracker pageName={'wbm/Welcome/login/recovery/account/mail_new'} />

    <CustomH>
      <FormattedMessage {...messages.title} />
    </CustomH>

    <CustomP>
      <FormattedMessage {...messages.description} />
    </CustomP>

    <TextInput
      name={'newEmail'}
      onChange={handleChange}
      value={newEmail}
      label={<FormattedMessage {...messages.inputLabel} />}
      message={newEmailError}
      type={'email'}
      size={'m'}
      required
      autoFocus
      readOnly={isSubmitting}
      disabled={isSubmitting}
    />

    <StretchButtonGroup>
      <Button loading={isSubmitting} type={'submit'}>
        <FormattedMessage {...messages.buttonContinue} />
      </Button>

      <Spacer size={4} />

      {newEmailError && (
        <TextButton to={'/'}>
          <FormattedMessage {...messages.buttonToLogin} />
        </TextButton>
      )}
    </StretchButtonGroup>
  </>
);

NewEmailStep.propTypes = {
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({ newEmailError: PropTypes.string }),
  values: PropTypes.shape({ newEmail: PropTypes.string }),
};

export default NewEmailStep;
